import { PersonalInformationFieldNames } from "features/new-actor/enums/personalInformationFieldNames";
import { ContactFormValues } from "features/new-actor/types/contactFormValues";
import { InputsConfig } from "types/form/inputsConfig";
import { personalInformationInputsConfig } from "./personalInformationInputsConfig";

export const contactInputsConfig: InputsConfig<keyof ContactFormValues> = Object.keys(personalInformationInputsConfig)
  .filter(key => key !== PersonalInformationFieldNames.BirthDate)
  .reduce((acc, key) => {
    acc[key as PersonalInformationFieldNames] = personalInformationInputsConfig[key as PersonalInformationFieldNames];
    return acc;
  }, {} as InputsConfig<PersonalInformationFieldNames>);
